import type { ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import DiceGame from '@/components/games/dice-game'
import { GameHeader } from '@/components/games/game-ui'
import { GAMES } from '@/constants/site'

const game = GAMES[1]

const DicePage = (): ReactNode => {
    return (
        <>
            <Seo title='Dice' description='Set your own odds and roll under your number to win up to 49× your DonutSMP money.' />
            <GameHeader title={game.name} subtitle={game.subtitle} />
            <DiceGame />
        </>
    )
}

export default DicePage
